<template>
  <div>
    <table class="table-page">
      <thead>
      <tr class="table-header">
        <th class="table-header_th table-header_th-select table-content_sticky-th" rowspan="2" ref="firstColTh">
          <div>
            {{ $t('takeBoxPlace') }}
<!--            <a-dropdown placement="bottomCenter">-->
<!--              <a-icon type="down" />-->
<!--&lt;!&ndash;              <a-icon type="setting" />&ndash;&gt;-->
<!--              <a-menu slot="overlay">-->
<!--                <a-menu-item>-->
<!--                  <a @click="openSetting">{{ $t('filterCity') }}</a>-->
<!--                </a-menu-item>-->
<!--              </a-menu>-->
<!--            </a-dropdown>-->
          </div>
        </th>
        <th class="table-header_th table-content_sticky-th" :style="{left: firstColWidth + 'px'}" rowspan="2"
            ref="secondColTh">{{ $t('通用_箱型') }}
        </th>
        <th class="table-header_th table-content_sticky-th" :style="{left: firstColWidth + secondColWidth + 'px'}"
            rowspan="2">{{ $t('boxStatus') }}
        </th>
<!--        <th class="table-header_th" rowspan="2">{{ $t('almostThere') }}</th>-->
<!--        <th class="table-header_th" rowspan="2">{{ $t('nowBoxNum') }}</th>-->
        <th class="table-header_th table-header_th-title" :colspan="rCityArr.length">{{ $t('通用_还箱地') }}</th>
      </tr>
      <tr class="table-header">
        <th class="table-header_th" v-for="(item,index) of rCityArr" :key="index">{{ $dt(item, 'CITY_NAME') }}</th>
      </tr>
      </thead>
      <div class="table-spin" v-if="loading">
        <a-spin size="large"/>
      </div>
      <template v-else-if="dataListInfo.length > 0">
        <tr class="table-content_tr" v-for="(item,index) in dataListInfo" :key="index">
          <td class="table-content_left-td" :rowspan="item.number ? item.number : 1" v-if="item.number">
            {{ $dt(item, 'CITY_NAME') }}
          </td>
          <td class="table-content_td table-content_sticky-td" :rowspan="item.boxNumber ? item.boxNumber: 1"
              v-if="item.boxNumber" :style="{left: firstColWidth + 'px'}">{{ $dt(item, 'BOX_SIZE_NAME') }}
          </td>
          <td class="table-content_td table-content_sticky-td" :style="{left: firstColWidth + secondColWidth + 'px'}">
            {{ $dt(item, 'BOX_STATE_NAME') }}
          </td>
<!--          <td class="table-content_td">{{ item.ESTIM_BOX || '&#45;&#45;' }}</td>-->
<!--          <td class="table-content_td">{{ item.ALREADY_BOX || '&#45;&#45;' }}</td>-->
          <td class="table-content_td" v-for="(price,index) in item.city">
            <a-popover>
              <template slot="content">
                <div class="use-box-content">
                  <div class="use-box-popover-title">{{
                      $dt(item, 'CITY_NAME')
                    }}-{{ $dt(item.city[index], 'D_CITY_NAME') }}
                  </div>
                  <div class="use-box-popover-size">{{ $dt(item, 'BOX_SIZE_NAME') }} {{
                      $dt(item, 'BOX_STATE_NAME')
                    }}
                  </div>
                  <div class="use-box-bottom">
                    <div class="use-box-bottom-price">
                      <span class="use-box-bottom-valid-price"
                            v-if="item.city[index].PROM_PRICE && item.city[index].IS_CBC">
                         <span v-if="item.city[index].PROM_PRICE < 0"
                               style="color: #FF6F27;font-size: 16px;">{{ $t('subsidy') }}</span>
                        ${{ item.city[index].PROM_PRICE }}
                      </span>
                      <span v-if="item.city[index].IS_CBC">
                       {{ $t('cassByCass') }}
                      </span>
                      <span v-else class="use-box-bottom-prom-price">
                        <div v-if="item.city[index].PROM_PRICE && item.city[index].ROUTE_QTY > 0">
                            <span v-if="item.city[index].PROM_PRICE < 0"
                                  style="color: #FF6F27;font-size: 16px;">{{ $t('subsidy') }}</span>{{Math.abs(item.city[index].PROM_PRICE)}}
                        </div>
                        <div v-else-if="item.city[index].VALID_PRICE">
                          <span v-if="item.city[index].VALID_PRICE < 0"
                                style="color: #FF6F27;font-size: 16px;">{{ $t('subsidy') }}</span>{{Math.abs(item.city[index].VALID_PRICE)}}
                        </div>
                        <div v-else>
                          --
                        </div>
                    </span>
                      <span class="use-box-bottom-price_box_word"> /{{ $t('box') }}</span>
                    </div>
                  </div>
                  <a-button type="primary" @click="gotoApple(item,item.city[index])">{{ $t('applyToBox') }}</a-button>
                </div>
              </template>
              <div style="color: #FF6F27" v-if="price.PROM_PRICE && price.IS_CBC && price.ROUTE_QTY > 0">
                <span v-if="price.PROM_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{ $t('subsidy') }}</span>${{Math.abs(price.PROM_PRICE)}}
              </div>
              <div v-else-if="price.IS_CBC">
                {{$t('CBC')}}
              </div>
              <div v-else>
                <span v-if="price.PROM_PRICE && !price.IS_CBC && price.VALID_PRICE && price.ROUTE_QTY > 0" style="text-decoration: line-through;color: #333333">
                    <span v-if="price.VALID_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{ $t('subsidy') }}</span>${{Math.abs(price.VALID_PRICE)}}
                </span>
                <span v-if="price.PROM_PRICE && price.ROUTE_QTY > 0"  style="color: #FF6F27">
                  <span v-if="price.PROM_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{ $t('subsidy') }}</span>${{Math.abs(price.PROM_PRICE)}}
                </span>
                <span v-else-if="price.VALID_PRICE">
                  <span v-if="price.VALID_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{ $t('subsidy') }}</span>${{Math.abs(price.VALID_PRICE)}}
                </span>
                <div v-else>
                  --
                </div>
              </div>
            </a-popover>
          </td>
        </tr>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </table>

    <!--城市选择窗口-->
    <a-modal v-model.trim="settingVisible" :title="$t('selectCity')" width="1000px" @ok="confirmSetting">
      <div v-if="errorAlert" class="error-alert">{{ $t('citySelectHint') }}</div>
      <a-row type="flex">
        <a-col :span="11">
          <div class="city_title">
            <div><a-icon style="margin-right: 6px;" type="environment" />{{ $t('takeBoxPlace') }}</div>
            <div class="city_title-icon" @click="clearCity('leftCity')"><a-icon style="margin-right: 4px;" type="delete" />
              {{ $t('clear') }}</div>
          </div>
          <a-row type="flex">
            <template v-for="(item,index) of leftCityList">
              <a-col
                  :class="{'city-block': true, active: leftCityPicked.indexOf(item.CITY_ID) !== -1}"
                  @click="pickCity('leftCity', item)"
              >
                <span>{{ $dt(item, 'CITY_NAME') }}</span>
              </a-col>
            </template>
          </a-row>
        </a-col>
        <a-col style="text-align: center" :span="2">
          <a-divider style="height: 100%" type="vertical"/>
        </a-col>
        <a-col :span="11">
          <div class="city_title">
            <div><a-icon style="margin-right: 6px" type="environment" />{{ $t('通用_还箱地') }}</div>
<!--            <div><a-button @click="clearCity('topCity')">清空</a-button></div>-->
            <div class="city_title-icon" @click="clearCity('topCity')"><a-icon style="margin-right: 4px;" type="delete" />{{ $t('clear') }}</div>
          </div>
          <a-row type="flex">
            <template v-for="(item,index) of topCityList">
              <a-col
                  :class="{'city-block': true, active: topCityPicked.indexOf(item.CITY_ID) !== -1}"
                  @click="pickCity('topCity', item)"
              >
                <span>{{ $dt(item, 'CITY_NAME') }}</span>
              </a-col>
            </template>
          </a-row>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
const BOX_SIZE_20GP = 10000008;
const BOX_SIZE_40HQ = 10000012;
const DEFAULT_CITY_LIMIT = 5;

export default {
  name: "price-table",
  props: {
    nation: {type: Number, default: 10000005}, // 左侧国家
    rNation: {type: Number, default: 10000006}, // 列国家
  },
  data() {
    this.getCityData = this.$Dolphin.debounce(this.getCityData, 500);
    this.getPriceData = this.$Dolphin.debounce(this.getPriceData, 500);

    return {
      dataListInfo: [],
      rCityArr: [],
      firstColWidth: 0,
      secondColWidth: 0,
      loading: false,

      leftCityList: [],
      leftCitySelect: [],

      topCityList: [],
      topCitySelect: [],

      originData: [],
      priceData: [],

      settingVisible: false,
      leftCityPicked: [],
      topCityPicked: [],

      boxSize: [BOX_SIZE_20GP, BOX_SIZE_40HQ], // 列国家
      errorAlert: false
    };
  },
  watch: {
    nation() {
      this.getCityData();
    },
    rNation() {
      this.getCityData();
    },
  },
  computed: {},
  methods: {
    getCityData() {
      const sql = `SELECT * FROM GM_CITY WHERE NATION IN (${this.nation}, ${this.rNation})`;
      const sendData = [this.$dotNetUtil.commonQueryJson(sql, {NUM2_number: 1,STATUS:1}, 2, 'NUM1 DESC')];
      this.loading = true;
      this.$h5Api({
        type: '1001',
        data: sendData,
        loading: false,
      }).then(data => {
        this.leftCityList = data.data.DATA_LIST.filter(item => item.NATION === this.nation);
        this.topCityList = data.data.DATA_LIST.filter(item => item.NATION === this.rNation);

        this.autoSetSelectCity('leftCity');
        this.autoSetSelectCity('topCity');

        this.getPriceData();
      });
    },
    autoSetSelectCity(type) {
      const localStorageStr = localStorage.getItem(`${this.$store.state.userInfo.USER_ID}${type === 'leftCity' ? this.nation : this.rNation}CitySelect`);
      if (localStorageStr) {
        const localSelect = JSON.parse(localStorageStr);
        this[type + 'Select'] = localSelect.filter(CITY_ID => this[`${type}List`].find(item => item.CITY_ID === CITY_ID));
      } else {
        this[type + 'Select'] = this[type + 'List'].slice(0, DEFAULT_CITY_LIMIT).map(item => item.CITY_ID);
      }
    },
    autoSetSelectBoxSize() {
      const localStorageStr = localStorage.getItem(`${this.$store.state.userInfo.USER_ID}PriceTableBoxSize`);
      if (localStorageStr) {
        this.boxSize = JSON.parse(localStorageStr);
      }
      this.$emit('setBoxSize', this.boxSize);
    },
    pickCity(type, data) {
      const suffix = 'Picked';
      const index = this[type + suffix].findIndex(item => item === data.CITY_ID);
      if (index >= 0) {
        this[type + suffix].splice(index, 1);
      } else {
        if (this[type + suffix].length >= 10) {
          this.$message.error(this.$t('selectCityLimit'));
        } else {
          this[type + suffix].push(data.CITY_ID);
        }
      }
    },

    getPriceData() {
      let condition = {
        QUERY_TYPE: 2,
        COMPANY_ID: this.$store.state.userInfo?.COMPANY_ID,
        RANK_ID: this.$store.state.userInfo?.RANK_ID,
        NATION: this.nation,
        D_NATION: this.rNation,
        CITY_IDS: this.leftCitySelect.join(','),
        D_CITY_IDS: this.topCitySelect.join(','),
      };
      this.loading = true;
      this.$h5Api({
        type: '3001',
        data: [condition],
        showMessage: true,
        loading: false,
      }).then(({data}) => {
        this.originData = data.JT_COMPANY_PRICE;
        this.formatData();
      }).finally(e => {
        this.loading = false;
      });
    },

    openSetting() {
      this.leftCityPicked = [...this.leftCitySelect];
      this.topCityPicked = [...this.topCitySelect];
      this.settingVisible = true;
    },
    clearCity(type) {
      const suffix = 'Picked';
      this[type + suffix] = []
    },
    confirmSetting() {
      this.leftCitySelect = [...this.leftCityPicked];
      this.topCitySelect = [...this.topCityPicked];
      if (this.leftCitySelect.length <= 0 || this.topCitySelect.length <= 0 ) {
        this.errorAlert = true
        return true
      } else {
        this.errorAlert = false
      }

      localStorage.setItem(`${this.$store.state.userInfo.USER_ID}${this.nation}CitySelect`, JSON.stringify(this['leftCitySelect']));
      localStorage.setItem(`${this.$store.state.userInfo.USER_ID}${this.rNation}CitySelect`, JSON.stringify(this['topCitySelect']));

      this.getPriceData();
      this.settingVisible = false;
    },

    formatData() {
      let rowMap = {};
      let rows = [];
      let cityBoxMap = {};
      let boxList = [];
      let boxStateList = [];
      let rCityMap = {};
      let rCityArr = [];
      this.originData.forEach(item => {
        //过滤不需要的城市
        if (this.leftCitySelect.length > 0 && this.leftCitySelect.indexOf(item.CITY_ID) === -1) {
          return true;
        }
        if (this.topCitySelect.length > 0 && this.topCitySelect.indexOf(item.D_CITY_ID) === -1) {
          return true;
        }

        //过滤不需要的箱型
        if (!this.boxSize.find(size => size === item.BOX_SIZE)) {
          return false;
        }

        //准备顶部城市map
        rCityMap[item.D_CITY_ID] = {
          CITY_ID: item.D_CITY_ID,
          CITY_NAME: item.D_CITY_NAME,
          CITY_NAME_ENG: item.D_CITY_NAME_ENG,
          CITY_NAME_RUS: item.D_CITY_NAME_RUS,
          D_CITY_ORDER: item.D_CITY_ORDER
        };

        //获取所有的箱型
        if (boxList.indexOf(item.BOX_SIZE) === -1) {
          boxList.push(item.BOX_SIZE);
        }

        //获取所有的箱况
        if (boxStateList.indexOf(item.BOX_STATE) === -1) {
          boxStateList.push(item.BOX_STATE);
        }

        //根据CITY_ID、BOX_SIZE、D_CITY_ID、BOX_STATE整理数据map
        rowMap[item.CITY_ID + '_' + item.BOX_SIZE + '_' + item.D_CITY_ID + '_' + item.BOX_STATE] = {
          CITY_ID: item.CITY_ID,
          CITY_NAME: item.CITY_NAME,
          CITY_NAME_ENG: item.CITY_NAME_ENG,
          CITY_NAME_RUS: item.CITY_NAME_RUS,
          CITY_ORDER: item.CITY_ORDER,
          BOX_SIZE_NAME: item.BOX_SIZE_NAME,
          BOX_SIZE_NAME_ENG: item.BOX_SIZE_NAME_ENG,
          BOX_SIZE_NAME_RUS: item.BOX_SIZE_NAME_RUS,
          BOX_STATE: item.BOX_STATE,
          BOX_STATE_NAME: item.BOX_STATE_NAME,
          BOX_STATE_NAME_ENG: item.BOX_STATE_NAME_ENG,
          BOX_STATE_NAME_RUS: item.BOX_STATE_NAME_RUS,
          BOX_SIZE: item.BOX_SIZE,
          IS_CBC: item.IS_CBC,
          D_CITY_ID: item.D_CITY_ID,
          D_CITY_NAME: item.D_CITY_NAME,
          D_CITY_NAME_ENG: item.D_CITY_NAME_ENG,
          D_CITY_NAME_RUS: item.D_CITY_NAME_RUS,
          D_CITY_ORDER: item.D_CITY_ORDER,
          VALID_PRICE: item.VALID_PRICE,
          PROM_PRICE: item.PROM_PRICE,
          ESTIM_BOX: item.ESTIM_BOX,
          ALREADY_BOX: item.ALREADY_BOX,
        };
      });

      //生成右侧城市列表
      for (let rCity in rCityMap) {
        rCityArr.push(rCityMap[rCity]);
      }
      // 按排序字段排序
      rCityArr.sort((a, b) => {
        return b.D_CITY_ORDER - a.D_CITY_ORDER ? 1 : -1;
      });
      this.rCityArr = rCityArr;

      //根据格数据，转为行数据
      for (let row in rowMap) {
        const [CITY_ID, BOX_SIZE, D_CITY_ID, BOX_STATE] = row.split('_');
        const cityBoxKey = `${CITY_ID}_${BOX_SIZE}_${BOX_STATE}`;

        //根据CITY_ID和BOX_SIZE整理数据
        if (!cityBoxMap[cityBoxKey]) {
          //不存在，初始化行
          cityBoxMap[cityBoxKey] = {
            BOX_SIZE: rowMap[row]['BOX_SIZE'],
            BOX_SIZE_NAME: rowMap[row]['BOX_SIZE_NAME'],
            BOX_SIZE_NAME_ENG: rowMap[row]['BOX_SIZE_NAME_ENG'],
            BOX_SIZE_NAME_RUS: rowMap[row]['BOX_SIZE_NAME_RUS'],
            BOX_STATE: rowMap[row]['BOX_STATE'],
            BOX_STATE_NAME: rowMap[row]['BOX_STATE_NAME'],
            BOX_STATE_NAME_ENG: rowMap[row]['BOX_STATE_NAME_ENG'],
            BOX_STATE_NAME_RUS: rowMap[row]['BOX_STATE_NAME_RUS'],
            CITY_ID: rowMap[row]['CITY_ID'],
            CITY_NAME_ENG: rowMap[row]['CITY_NAME_ENG'],
            CITY_NAME: rowMap[row]['CITY_NAME'],
            CITY_NAME_RUS: rowMap[row]['CITY_NAME_RUS'],
            CITY_ORDER: rowMap[row]['CITY_ORDER'],
            ESTIM_BOX: rowMap[row]['ESTIM_BOX'],
            IS_CBC: rowMap[row]['IS_CBC'],
            ALREADY_BOX: rowMap[row]['ALREADY_BOX'],
            PROM_PRICE: rowMap[row]['PROM_PRICE'],
          };

          // 创建右侧城市数组
          cityBoxMap[cityBoxKey].city = [];
        }

        cityBoxMap[cityBoxKey].city.push({
          D_CITY_ID: rowMap[row]['D_CITY_ID'],
          D_CITY_NAME_RUS: rowMap[row]['D_CITY_NAME_RUS'],
          D_CITY_NAME: rowMap[row]['D_CITY_NAME'],
          D_CITY_NAME_ENG: rowMap[row]['D_CITY_NAME_ENG'],
          VALID_PRICE: rowMap[row]['VALID_PRICE'],
          IS_CBC: rowMap[row]['IS_CBC'],
          ESTIM_BOX: rowMap[row]['ESTIM_BOX'],
          ALREADY_BOX: rowMap[row]['ALREADY_BOX'],
          PROM_PRICE: rowMap[row]['PROM_PRICE'],
          D_CITY_ORDER: rowMap[row]['D_CITY_ORDER'],
        });
      }
      for (let cityBoxKey in cityBoxMap) {
        // 过滤整行没有价格的城市
        let priceFlag = true;
        cityBoxMap[cityBoxKey].city?.forEach(item1 => {
          if (item1.IS_CBC === 1 || item1.PROM_PRICE !== 0 || item1.VALID_PRICE !== 0) {
            priceFlag = false;
          }
        });
        if (priceFlag) {
          delete cityBoxMap[cityBoxKey];
          continue;
        }

        cityBoxMap[cityBoxKey].city?.sort((a, b) => {
          return b.D_CITY_ORDER - a.D_CITY_ORDER ? 1 : -1;
        });
        rows.push(cityBoxMap[cityBoxKey]);
      }

      // 按排序字段排序
      rows.sort((a, b) => {
        let flag;
        if (a.CITY_ID === b.CITY_ID) {
          if (a.BOX_SIZE === b.BOX_SIZE) {
            flag = a.BOX_STATE > b.BOX_STATE ? 1 : -1;
          } else {
            flag = a.BOX_SIZE > b.BOX_SIZE ? 1 : -1;
          }
        } else {
          flag = b.CITY_ORDER > a.CITY_ORDER ? 1 : -1;
        }
        return flag;
      });

      // 计算每行的高度
      let cityNum = {};
      let boxArrNum = {};
      for (let item in cityBoxMap) {
        const [CITY_ID, BOX_SIZE, BOX_STATE] = item.split('_');
        if (!cityNum[CITY_ID]) {
          cityNum[CITY_ID] = 0;
        }
        if (!boxArrNum[`${CITY_ID}_${BOX_SIZE}`]) {
          boxArrNum[`${CITY_ID}_${BOX_SIZE}`] = 0;
        }

        cityNum[CITY_ID]++;
        boxArrNum[`${CITY_ID}_${BOX_SIZE}`]++;
      }

      for (let CITY_ID in cityNum) {
        const firstCityRow = rows.find(item => String(item.CITY_ID) === String(CITY_ID));
        firstCityRow.number = cityNum[CITY_ID];
      }
      for (let boxArrKey in boxArrNum) {
        const [CITY_ID, BOX_SIZE] = boxArrKey.split('_');
        const firstCityBoxSizeRow = rows.find(item => String(item.CITY_ID) === String(CITY_ID) && String(item.BOX_SIZE) === String(BOX_SIZE));
        firstCityBoxSizeRow.boxNumber = boxArrNum[boxArrKey];
      }

      this.dataListInfo = rows;
      this.$nextTick(() => {
        this.firstColWidth = this.$refs.firstColTh.offsetWidth;
        this.secondColWidth = this.$refs.secondColTh.offsetWidth;
      });
    },
    gotoApple(data, val) {
      data.IS_CBC = val.IS_CBC;
      data.D_CITY_ID = val.D_CITY_ID;
      data.PROM_PRICE = val?.PROM_PRICE || val?.VALID_PRICE;
      this.$emit('gotoApply', data);
    },

    setBoxSize(boxSizeList) {
      this.boxSize = boxSizeList;
      localStorage.setItem(`${this.$store.state.userInfo.USER_ID}PriceTableBoxSize`, JSON.stringify(boxSizeList));
      this.formatData();
    }
  },
  created() {
    this.getCityData();
    this.autoSetSelectBoxSize();
  }
};
</script>

<style lang="scss">
.table-page {
  margin-top: 10px;
  overflow: auto;
  display: block;
  width: 100%;
  max-height: 600px;

  th, td {
    white-space: nowrap;
    width: 5%;
    border: 1px solid #86C2FF;
  }

  .table-spin {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 3;
    background: linear-gradient(270deg, #39A4F7 0%, #1F6CBA 100%);
  }

  .table-header {
    color: #FFFFFF;
    border: 1px solid #86C2FF;
    text-align: center;
    border-radius: 4px 4px 0px 0px;

    .table-header_th {
      padding: 4px 20px;
    }

    .table-content_sticky-th {
      position: sticky;
      left: 0;
      z-index: 2;
      background: #1F6CBA;
    }

    .table-header_th-title {

    }

    .table-header_th-select {
      cursor: pointer;
    }
  }

  .table-content_tr {
    border: 1px solid #86C2FF;
    text-align: center;
    background: #EBF3FA;

    &:nth-child(2n) {
      background: #FFFFFF;
    }

    .table-content_left-td {
      border: 1px solid #86C2FF;
      background: #E4F2FF;
      font-size: 14px;
      width: 100px;
      font-weight: 600;
      color: #17528D;
      position: sticky;
      left: 0;
      z-index: 2;
    }

    .table-content_sticky-td {
      border: 1px solid #86C2FF;
      background: #E4F2FF;
      font-size: 14px;
      font-weight: 600;
      color: #17528D;
      position: sticky;
      left: 100px;
      z-index: 2;

      span {
        cursor: pointer;
      }
    }

    .table-content_td {
      border: 1px solid #86C2FF;
      padding: 10px 0;

      span {
        cursor: pointer;
      }
    }
  }
}
.error-alert {
  text-align: center;
  color: red;
  margin-bottom: 6px;
}
.city_title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #333333;
  margin-bottom: 18px;
  font-size: 16px;
  .city_title-icon{
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    cursor: pointer;
  }
}

.city-popover {
  min-width: 274px;
  max-width: 600px;

  .city-popover-title {
    font-size: 12px;
    color: #666666;
    margin-bottom: 10px;
  }

  .city-popover-box {
    padding: 6px 22px;
    background: #F5F5F5;
    border-radius: 4px;
    margin: 5px;
    cursor: pointer;
  }

  .active {
    margin: 5px;
    padding: 5px 21px;
    background: #EBF3FA;
    border-radius: 4px;
    border: 1px solid #2982D2;
    cursor: pointer;
  }
}


.city-block {
  padding: 6px 22px;
  background: #F5F5F5;
  border-radius: 4px;
  margin: 5px;
  cursor: pointer;

  &.active {
    padding: 5px 21px;
    background: #EBF3FA;
    border: 1px solid #2982D2;
    color: #1F6CBA;
  }
}


.rCity-popover {
  width: 400px;

  .rCity-popover-title {
    font-size: 12px;
    color: #666666;
    margin-bottom: 10px;
  }

  .rCity-popover-box {
    padding: 6px 22px;
    background: #F5F5F5;
    border-radius: 4px;
    margin: 5px;
    cursor: pointer;
  }

  .active {
    margin: 5px;
    padding: 5px 21px;
    background: #EBF3FA;
    border-radius: 4px;
    border: 1px solid #2982D2;
    cursor: pointer;
  }
}

.use-box-content {
  .use-box-popover-title {
    font-weight: 600;
    color: #484747;
    margin-bottom: 10px;
    font-size: 16px;
  }

  .use-box-popover-size {
    color: #666666;
  }

  .use-box-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;


    .use-box-bottom-price {
      font-size: 16px;
      font-weight: 600;

      .use-box-bottom-valid-price {
        font-size: 16px;
        font-weight: 400;
        text-decoration: line-through;
        margin-right: 5px;
      }

      .use-box-bottom-prom-price {
        color: #FF6F27;
      }

      .use-box-bottom-price_box_word{
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
}

</style>